export { SpaceVentureInvestmentsPage as default } from "@nvb/ui";
